import { useState, useEffect } from "react";
import { api, timeAgo } from "../../context";

export default function Content({ t }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [flash, setFlash] = useState("");

  const CARD=t.card,BORDER=t.border,TEXT=t.text,SUB=t.sub,PRI=t.pri,GRN=t.grn,RED=t.red,GOLD=t.gold;
  const showFlash = (msg) => { setFlash(msg); setTimeout(() => setFlash(""), 3000); };

  const load = async () => {
    setLoading(true);
    const r = await api("/admin/flagged-posts");
    if (r.ok) setPosts(r.data?.data || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const moderate = async (id, action) => {
    const r = await api(`/admin/posts/${id}/moderate`, { method: "POST", body: JSON.stringify({ action }) });
    if (r.ok) { showFlash(`Post ${action}d ✓`); load(); }
  };

  return (
    <div>
      {flash && <div style={{ position: "fixed", top: 20, right: 20, background: GRN, color: "#fff", padding: "10px 20px", borderRadius: 10, fontWeight: 700, fontSize: 13, zIndex: 9999 }}>{flash}</div>}

      <div style={{ fontSize: 22, fontWeight: 800, color: TEXT, marginBottom: 4 }}>📝 Content Moderation</div>
      <div style={{ fontSize: 12, color: SUB, marginBottom: 24 }}>Review and moderate flagged posts</div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12, marginBottom: 20 }}>
        {[
          { label: "Flagged Posts", value: posts.length, color: RED },
          { label: "Pending Review", value: posts.filter(p => p.status === "flagged").length, color: GOLD },
          { label: "Moderated Today", value: 0, color: GRN },
        ].map((s, i) => (
          <div key={i} style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 12, padding: "18px 20px" }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: SUB, textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>{s.label}</div>
            <div style={{ fontSize: 26, fontWeight: 800, color: s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      {loading && <div style={{ textAlign: "center", padding: 40, color: SUB }}>Loading...</div>}

      {!loading && !posts.length && (
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "60px 24px", textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}>✅</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: TEXT, marginBottom: 8 }}>No flagged content</div>
          <div style={{ fontSize: 13, color: SUB }}>All posts are clean!</div>
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {posts.map(p => (
          <div key={p.id} style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 36, height: 36, borderRadius: 18, background: `linear-gradient(135deg, ${PRI}, #a23ad1)`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>
                  {p.user?.avatar_emoji || "👤"}
                </div>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: TEXT }}>{p.user?.name || "Unknown"}</div>
                  <div style={{ fontSize: 11, color: SUB }}>{timeAgo(p.created_at)} · {p.topic?.name || "General"}</div>
                </div>
              </div>
              <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, background: `${RED}20`, color: RED }}>
                {p.status}
              </span>
            </div>
            <div style={{ fontSize: 13, color: TEXT, lineHeight: 1.6, marginBottom: 14, padding: "12px 14px", background: t.input, borderRadius: 10 }}>
              {p.content}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={() => moderate(p.id, "approve")} style={{ padding: "8px 16px", borderRadius: 9, border: "none", background: `${GRN}20`, color: GRN, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>✓ Approve</button>
              <button onClick={() => moderate(p.id, "hide")} style={{ padding: "8px 16px", borderRadius: 9, border: `1px solid ${BORDER}`, background: "transparent", color: GOLD, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>👁 Hide</button>
              <button onClick={() => moderate(p.id, "delete")} style={{ padding: "8px 16px", borderRadius: 9, border: "none", background: `${RED}20`, color: RED, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>🗑 Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}